import cookieWallModalHtml from './modal/cookieWallModal.html';
import cookieWallModalController from './modal/cookieWallModal.controller';

class CookieWallController {
    constructor($scope, ModalService, $timeout) {
        'ngInject';

        this.$scope = $scope;
        this.modalService = ModalService;
        this.$timeout = $timeout;
    }

    $onInit() {
        if (window.location.pathname.startsWith('/admpanel')) {
            return;
        }
    
        this.$timeout(() => {
            this.detectCookies();
        }, 100);

        window.addEventListener('showCookieWallModal', () => {
            console.log('showCookieWallModal - event');
            this.openModal();
        });
    }

    openModal() {
        console.log('openModal', this.modalService);
        this.modalService.showModal({
            template: cookieWallModalHtml,
            controller: cookieWallModalController,
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.modal('hide');
            }
        }).then(modal => {
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.close.then(result => {
                window.dispatchEvent(new Event('popupClosed'));
            });
        });
    }

    detectCookies() {
        console.log('detectCookies');
        let isSet = this.getCookie('acceptCookies');

        if (!isSet || (!isSet.includes('0') && !isSet.includes('5')) && (!isSet.includes('1') || !isSet.includes('2'))) {
            this.openModal();
        }
    }

    getCookie(cname) {
        let name = cname + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }

        return "";
    }
}

let cookieWallComponent = {
    bindings: {},
    controller: CookieWallController
};

export default cookieWallComponent;
